export default "__VITE_ASSET__debfc3be__"